import { ApiClient } from '../../Shared/interfaces/ApiClient';
import { EDIT_INVENTORY_ENDPOINTS } from '../constants/endpoints';
import {
  TYPE_OF_PURCHASE_TRANSFORM_MAP,
  SLOT_PACKAGE_NAME_TRANSFORM_MAP,
} from '../../Shared/constants/transformMappings';
import {
  UpdateCpmPayload,
  UpdateCpmResponse,
} from '../interfaces/service.interfaces';

const { UPDATE_CPM } = EDIT_INVENTORY_ENDPOINTS;

export const updateCpm = async (
  api: ApiClient,
  payload: UpdateCpmPayload
): Promise<UpdateCpmResponse> => {
  const transformedPayload = {
    ...payload,
    typeOfPurchase:
      TYPE_OF_PURCHASE_TRANSFORM_MAP[payload.typeOfPurchase] ||
      payload.typeOfPurchase,
    slotPackageName:
      SLOT_PACKAGE_NAME_TRANSFORM_MAP[payload.slotPackageName] ||
      payload.slotPackageName,
  };
  return (await api.post(UPDATE_CPM, transformedPayload)) as UpdateCpmResponse;
};
